import { Activity } from 'react'
import { Panel } from 'react-resizable-panels'

import { CollapsibleResizeHandle } from '../../components/collapsibleResizeHandle/CollapsibleResizeHandle'
import { useLayoutContext } from '../../context/layoutContext'
import { ReconciliationSpecSidebar } from './ReconciliationSpecSidebar'

export const ReconciliationSpecSidebarPanel = () => {
  const { onChangeView, preferences } = useLayoutContext()
  const {
    reconciliationSpecs: { isSidebarOpen },
  } = preferences

  const handleToggleSidebar = () => {
    onChangeView({
      ...preferences,
      reconciliationSpecs: {
        ...preferences.reconciliationSpecs,
        isSidebarOpen: !isSidebarOpen,
      },
    })
  }

  return (
    <>
      <Activity mode={isSidebarOpen ? 'visible' : 'hidden'}>
        <Panel
          className="size-full overflow-hidden"
          id="reconciliationSpecVersionsPanel"
          defaultSize="20%"
          minSize="5%"
        >
          <ReconciliationSpecSidebar />
        </Panel>
      </Activity>
      <CollapsibleResizeHandle
        id="resizeReconciliationSpecVersionsBar"
        isOpen={isSidebarOpen}
        onToggle={handleToggleSidebar}
      />
    </>
  )
}
